/* eslint-disable no-unused-vars */

import React, { memo, useCallback, useRef, useEffect } from 'react';
import _ from 'lodash';
import { useLocation, useSearchParams } from 'react-router-dom';
import AutoSizer from 'react-virtualized-auto-sizer';
import { useVirtualizer } from '@tanstack/react-virtual';

import style from './virtual.module.scss';
const VirtualList = ({
  data,
  addMarginToLastItem = false,
  component: Component,
  componentProps,
  itemSize = 30,
  divider = false,
  siteListingPage = false,
  gutter = 5,
  isGrid,
  overscan = 10,
  onScrollEvent = null,
  isHidden = false,
  noVirtualList = false,
  content: Content
}) => {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  const parentRef = useRef();
  const count = data.length;

  // Move DOM queries inside useEffect to prevent memory leaks
  const virtualListScrollAll = document?.querySelectorAll('.cstmScrollerRef');

  useEffect(() => {
    if (pathname.includes('-details')) {
      virtualListScrollAll.forEach((virtualList) => {
        if (virtualList) {
          virtualList.classList.remove('virtualListOverflowOverlay');
          virtualList.classList.add('virtualListOverflowOverlay');
        }
      });
    }

    // Cleanup function to remove any added classes
    // return () => {
    //   if (pathname.includes('-details')) {
    //     const virtualListScrollAll = document?.querySelectorAll('.cstmScrollerRef');
    //     virtualListScrollAll.forEach((virtualList) => {
    //       if (virtualList) {
    //         virtualList.classList.remove('virtualListOverflowOverlay');
    //       }
    //     });
    //   }
    // };
  }, [virtualListScrollAll, pathname]);

  const virtualizer = useVirtualizer({
    count,
    getScrollElement: () => parentRef.current,
    estimateSize: () => itemSize,
    overscan
  });
  const items = virtualizer.getVirtualItems();

  const Row = useCallback(
    ({ virtualRow, data }) => {
      return (
        <div
          key={virtualRow.key}
          data-index={virtualRow.index}
          ref={virtualizer.measureElement}
          className={virtualRow.index % 2 ? 'ListItemOdd' : 'ListItemEven'}
          style={{
            marginBottom:
              addMarginToLastItem && virtualRow.index === data?.length - 1 ? '40px' : '0px'
          }}
        >
          <Component
            index={data[virtualRow.index]?.key || virtualRow.key}
            currentSiteIndex={data[virtualRow.index]?.siteActualIndex}
            {...data[virtualRow.index]}
            {...componentProps}
          />

          {divider && (
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <div
                style={{
                  width: '100%',

                  // margin: 10px auto;
                  borderTop: '1px solid rgb(203, 210, 217)'
                }}
              />
            </div>
          )}
        </div>
      );
    },
    [data, virtualizer, virtualizer.measureElement]
  );

  const Column = useCallback(
    ({ virtualRow, data }) => {
      return (
        <div
          key={virtualRow.key}
          data-index={virtualRow.index}
          ref={virtualizer.measureElement}
          // className={virtualRow.index % 2 ? 'ListItemOdd' : 'ListItemEven'}
          style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${isGrid}, minmax(0, 1fr))`, // ← change here
            gridColumnGap: gutter,
            gridAutoRows: 'minmax(auto, 1fr)'
          }}
        >
          {Array.from({ length: isGrid }).map((_, i) => {
            const dataIndex = virtualRow.index * isGrid + i;
            return dataIndex < data.length ? (
              <Component key={dataIndex} {...data[dataIndex]} {...componentProps} index={i} />
            ) : null;
          })}
        </div>
      );
    },
    [data, virtualizer, virtualizer.measureElement]
  );

  const onWheelEvent = useCallback(
    (event) => {
      if (!onScrollEvent) return;

      // Cache DOM elements to avoid repeated queries
      const virtualListScrollAll = document?.querySelectorAll('.cstmScrollerRef');
      const assetDetailsNavigation = document.getElementById('assetDetailsNavigation');
      const workOrderAndInspectionsListings = document.querySelector(
        '#workOrderAndInspectionsListings'
      );

      if (parseInt(searchParams.get('virtualScrollTab')) === -1) {
        const current = virtualListScrollAll[0];
        if (
          current &&
          virtualizer.getTotalSize() < current?.offsetHeight &&
          workOrderAndInspectionsListings?.classList?.value?.includes(
            'assetDetailsWorkOrderAndInspectionsFixed'
          )
        ) {
          if (event?.deltaY < 0) onScrollEvent();
        }
      } else {
        const currentTab = parseInt(searchParams.get('virtualScrollTab') || 0);
        const current = virtualListScrollAll[currentTab];
        if (
          current &&
          (virtualizer.getTotalSize() < current?.offsetHeight ||
            (virtualizer?.scrollOffset == 0 && !isHidden)) &&
          assetDetailsNavigation?.classList?.value?.includes('assetDetailNavFixed')
        ) {
          if (event?.deltaY < 0) onScrollEvent();
        }
      }
    },
    [onScrollEvent, searchParams, virtualizer, isHidden]
  );

  let startY = 0;
  let endY = 0;

  // const handleTouchStart = (event) => {
  //   startY = event.touches[0].clientY;
  // };

  // const handleTouchMove = (event) => {
  //   endY = event.touches[0].clientY;
  //   const deltaY = endY - startY;

  //   if (onScrollEvent) {
  //     if (parseInt(searchParams.get('virtualScrollTab')) === -1) {
  //       const current = virtualListScrollAll[0];
  //       if (
  //         virtualizer.getTotalSize() < current.offsetHeight &&
  //         workOrderAndInspectionsListings?.classList?.value?.includes(
  //           'assetDetailsWorkOrderAndInspectionsFixed'
  //         )
  //       ) {
  //         if (deltaY < 0) onScrollEvent();
  //       }
  //     } else {
  //       const currentTab = parseInt(searchParams.get('virtualScrollTab') || 0);
  //       const current = virtualListScrollAll[currentTab];
  //       if (
  //         (virtualizer.getTotalSize() < current.offsetHeight ||
  //           (virtualizer?.scrollOffset == 0 && !isHidden)) &&
  //         assetDetailsNavigation?.classList?.value?.includes('assetDetailNavFixed')
  //       ) {
  //         if (deltaY > 0) onScrollEvent();
  //       }
  //     }
  //   }
  // };

  // const handleTouchEnd = () => {
  //   startY = 0;
  //   endY = 0;
  // };

  // useEffect(() => {
  //   const test = document.getElementById('react-swipeable-virtual-list');

  //   if (test) {
  //     test.addEventListener('touchstart', handleTouchStart);
  //     test.addEventListener('touchmove', handleTouchMove);
  //     test.addEventListener('touchend', handleTouchEnd);
  //   }

  //   return () => {
  //     if (test) {
  //       test.removeEventListener('touchstart', handleTouchStart);
  //       test.removeEventListener('touchmove', handleTouchMove);
  //       test.removeEventListener('touchend', handleTouchEnd);
  //     }
  //   };
  // }, []);

  return noVirtualList ? (
    <div
      style={{
        padding: isGrid ? '16px' : ''
      }}
    >
      {isGrid ? (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${isGrid}, 1fr)`,
            gridColumnGap: gutter
            // gridAutoRows: 'minmax(auto, 1fr)'
          }}
          className={style.noVirtualListColumn}
        >
          {data.map((val, i) => {
            return <Component key={i} {...val} {...componentProps} index={i} />;
          })}
        </div>
      ) : (
        <Row data={data} />
      )}
    </div>
  ) : (
    <AutoSizer>
      {({ height, width }) => (
        <div
          id="react-swipeable-virtual-list"
          ref={parentRef}
          className="List cstmScrollerRef"
          style={{
            height: height,
            width: width,
            ...(!pathname.includes('-details') && { overflow: 'overlay' }),
            contain: 'strict',
            padding: isGrid ? '16px' : ''
          }}
          onScroll={onScrollEvent && onScrollEvent}
          // onWheel={onWheelEvent}
        >
          {Content ? <Content /> : <></>}
          <div
            style={{
              height: virtualizer.getTotalSize(),
              width: '100%',
              position: 'relative'
            }}
          >
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                // transform: `translateY(${items[0].start}px)`
                ...(items.length > 0 && { transform: `translateY(${items[0].start}px)` })
              }}
            >
              {items.map((virtualRow, index) =>
                isGrid ? (
                  <Column virtualRow={virtualRow} key={virtualRow.key} data={data} index={index} />
                ) : (
                  <Row virtualRow={virtualRow} key={virtualRow.key} data={data} index={index} />
                )
              )}
            </div>
          </div>
        </div>
      )}
    </AutoSizer>
  );
};

export default memo(VirtualList, _.isEqual);
